// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card-review__container[data-v-46272db9]{padding:24px 16px;background-color:#2C1A48;display:flex;flex-direction:column;gap:32px;border-radius:8px}.card-review__text[data-v-46272db9]{display:flex;flex-direction:column;gap:16px}.card-review__body[data-v-46272db9]{color:white}.card-review__body[data-v-46272db9] strong{font-weight:400;color:white;background-color:rgba(156,135,251,0.3)}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
